import React from 'react';

import { PlusIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { useAttachDepartmentUsersTranslation } from '../i18n';
import type { AttachDepartmentUsersProps } from '../types';
import { AttachDepartmentUsersDropdown } from './AttachDepartmentUsersDropdown';

type AttachDepartmentUsersButtonProps =
  AttachDepartmentUsersProps &
  Omit<ButtonProps, 'onClick'>;

const displayName = 'AttachDepartmentUsersButton';
const testid = buildTestid(displayName);

function AttachDepartmentUsersButton({
  departmentId,
  'data-testid': dataTestId = undefined,
  disabled = false,
  ...props
}: AttachDepartmentUsersButtonProps): React.JSX.Element {
  const { t } = useAttachDepartmentUsersTranslation();

  return (
    <AttachDepartmentUsersDropdown
      departmentId={departmentId}
      disabled={disabled}
    >
      <Button
        icon={<PlusIcon />}
        variant="flat"
        {...testid(dataTestId)}
        {...props}
      >
        {t('title')}
      </Button>
    </AttachDepartmentUsersDropdown>
  );
}

AttachDepartmentUsersButton.displayName = displayName;

export { AttachDepartmentUsersButton };
